




// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';

// const JobGrid = () => {
//   const [jobs, setJobs] = useState([]);
//   const [activeFilter, setActiveFilter] = useState('Recent Jobs');
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchJobs = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}job/alljob2?page=1&limit=10`);
//         const data = await response.json();
//         const sortedJobs = Array.isArray(data) ? data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) : [];
//         setJobs(sortedJobs);
//       } catch (error) {
//         console.error("Error fetching jobs:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchJobs();
//   }, []);

//   const getTimeAgo = (date) => {
//     const now = new Date();
//     const postedDate = new Date(date);
//     const monthsAgo = Math.floor((now - postedDate) / (1000 * 60 * 60 * 24 * 30));
//     return `${monthsAgo} month${monthsAgo !== 1 ? 's' : ''} ago`;
//   };

//   const filteredJobs = jobs
//     .filter(job => {
//       if (activeFilter === 'Recent Jobs') return true;
//       return job.workType.toLowerCase() === activeFilter.toLowerCase();
//     })
//     .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
//     .slice(0, 4);

//   if (loading) return <div className="text-center py-4">Loading...</div>;

//   return (
//     <div className="bg-white p-4 sm:p-6 w-auto flex flex-col flex-wrap px-4 lg:px-28"> {/* Added px-4 lg:px-8 for left/right padding */}
//       <div className="flex flex-col sm:flex-row justify-between items-center mb-4">
//         <div className="flex flex-row flex-wrap sm:flex-row justify-between items-center">
//           <div className="ml-50 items-center grid grid-cols-3 gap-3 w-full sm:flex sm:flex-row sm:gap-0 sm:w-auto "> {/* Removed ml-30 typo, adjusted to ml-0 */}
//             <div className="w-full flex justify-center sm:w-auto">
//               <button
//                 className={`w-full px-2 py-2 rounded-l ${activeFilter === 'Recent Jobs' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition sm:mr-4 sm:mb-3 sm:w-auto sm:px-4`} 
//                 onClick={() => setActiveFilter('Recent Jobs')}
//               >
//                 Recent Jobs
//               </button>
//             </div>
//             <div className="w-full flex justify-center sm:w-auto">
//               <button
//                 className={`w-full px-2 py-2 ${activeFilter === 'Part-Time' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition sm:mr-4 sm:mb-3 sm:w-auto sm:px-4`}
//                 onClick={() => setActiveFilter('Part-Time')}
//               >
//                 Part time
//               </button>
//             </div>
//             <div className="w-full flex justify-center sm:w-auto">
//               <button
//                 className={`w-full px-2 py-2 rounded-r ${activeFilter === 'Full-Time' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition sm:mr-4 sm:mb-3 sm:w-auto sm:px-4`}
//                 onClick={() => setActiveFilter('Full-Time')}
//               >
//                 Full Time
//               </button>
//             </div>
//             <div className="w-full flex justify-center sm:w-auto">
//               <button
//                 className={`w-full px-2 py-2 rounded-r ${activeFilter === 'Contract' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition sm:mr-4 sm:mb-3 sm:w-auto sm:px-4`}
//                 onClick={() => setActiveFilter('Contract')}
//               >
//                 Contract
//               </button>
//             </div>
//             <div className="w-full flex justify-center sm:w-auto">
//               <button
//                 className={`w-full px-2 py-2 rounded-r ${activeFilter === 'Freelance' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition sm:mr-4 sm:mb-3 sm:w-auto sm:px-4`}
//                 onClick={() => setActiveFilter('Freelance')}
//               >
//                 Freelance
//               </button>
//             </div>
//             <div className="w-full flex justify-center sm:w-auto">
//               <button
//                 className={`w-full px-2 py-2 rounded-r ${activeFilter === 'Remote' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition sm:mr-4 sm:mb-3 sm:w-auto sm:px-4`}
//                 onClick={() => setActiveFilter('Remote')}
//               >
//                 Remote
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 px-4 lg:px-28"> {/* Added px-4 lg:px-8 to match outer padding */}
//         {filteredJobs.map((job, index) => (
//           <div key={index} className="bg-gray-50 p-4 border border-gray-200 rounded-lg shadow-sm">
//             <div className="flex items-start justify-between">
//               <div>
//                 <h3 className="text-lg font-semibold text-gray-900">{job.jobTitle}</h3>
//                 {/* <p className="text-sm text-gray-600">{job.employer?.name || 'Unknown Employer'}</p> */}
//               </div>
//               <span className="text-sm text-gray-500">{job.workType}</span>
//             </div>
//             <div className="mt-2 text-sm text-gray-600">
//               <p className='font-sembold'><span className="text-orange-500">★</span> {job.localGovernment}, {job.state}</p>
//               <p>Experience Level: {job.experienceLength}</p>
//               <p>Posted: {getTimeAgo(job.createdAt)}</p>
//                <span className='font-semibold'>Salary: {job.salary} {job.currency}</span>

//             </div>
//                        {/* Engagement Stats - Beautiful Design */}
// <div className="flex items-center justify-between mt-6 pt-5 border-t border-gray-100">
//   <div className="flex items-center gap-6 text-sm">
    
//     {/* Likes */}
//     <div className="flex items-center gap-2 text-rose-500 hover:text-rose-600 transition-colors cursor-pointer">
//       <div className="bg-rose-50 p-2 rounded-xl">
//         ❤️
//       </div>
//       <div>
//         <span className="font-semibold text-base">{job.likes?.length || 0}</span>
//         <p className="text-xs text-gray-500 -mt-1">Likes</p>
//       </div>
//     </div>

//     {/* Views */}
//     <div className="flex items-center gap-2 text-emerald-600 hover:text-emerald-700 transition-colors cursor-pointer">
//       <div className="bg-emerald-50 p-2 rounded-xl">
//         👁️
//       </div>
//       <div>
//         <span className="font-semibold text-base">{job.uniqueViewers?.length || job.views || 0}</span>
//         <p className="text-xs text-gray-500 -mt-1">Views</p>
//       </div>
//     </div>

//     {/* Shares */}
//     <div className="flex items-center gap-2 text-blue-600 hover:text-blue-700 transition-colors cursor-pointer">
//       <div className="bg-blue-50 p-2 rounded-xl">
//         🔗
//       </div>
//         <div>
//         <span className="font-semibold text-base">{job.followers?.length || job.shares || 0}</span>
//         <p className="text-xs text-gray-500 -mt-1">Shares</p>
//       </div>
    
//     </div>

//   </div>
// </div>
//             <div className="mt-2 text-sm text-gray-600 flex justify-between">
             
// <div className="mt-2 text-sm text-gray-600 flex justify-end">
//   <Link
//     to={`/job/${job._id}`}
//     className="px-6 py-2.5 bg-orange-500 text-white font-medium rounded-md hover:bg-orange-600 transition-colors shadow-sm"
//   >
//     Apply Now
//   </Link>
// </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default JobGrid;









import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const FILTERS = ['Recent Jobs', 'Part-Time', 'Full-Time', 'Contract', 'Freelance', 'Remote'];

const JobGrid = () => {
  const [jobs, setJobs] = useState([]);
  const [activeFilter, setActiveFilter] = useState('Recent Jobs');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    const fetchJobs = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}job/alljob2?page=1&limit=10`, {
          signal: controller.signal,
        });
        const data = await response.json();
        const sortedJobs = Array.isArray(data) ? data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) : [];
        setJobs(sortedJobs);
      } catch (error) {
        if (error.name !== 'AbortError') console.error("Error fetching jobs:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchJobs();
    return () => controller.abort();
  }, []);

  const getTimeAgo = (date) => {
    const now = new Date();
    const postedDate = new Date(date);
    const monthsAgo = Math.floor((now - postedDate) / (1000 * 60 * 60 * 24 * 30));
    if (monthsAgo < 1) {
      const daysAgo = Math.floor((now - postedDate) / (1000 * 60 * 60 * 24));
      return daysAgo <= 0 ? 'Today' : `${daysAgo} day${daysAgo !== 1 ? 's' : ''} ago`;
    }
    return `${monthsAgo} month${monthsAgo !== 1 ? 's' : ''} ago`;
  };

  const filteredJobs = jobs
    .filter((job) => {
      if (activeFilter === 'Recent Jobs') return true;
      return job.workType?.toLowerCase() === activeFilter.toLowerCase();
    })
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .slice(0, 3);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-16">
        <div className="w-8 h-8 border-3 border-gray-200 border-t-orange-500 rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="bg-white py-4 sm:py-6 px-4 lg:px-28">
      {/* Filter bar */}
      <div className="flex flex-wrap justify-center sm:justify-start gap-2 mb-6">
        {FILTERS.map((filter) => (
          <button
            key={filter}
            onClick={() => setActiveFilter(filter)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors
              ${activeFilter === filter
                ? 'bg-orange-500 text-white shadow-sm'
                : 'bg-gray-100 text-gray-600 hover:bg-orange-100 hover:text-orange-600'}`}
          >
            {filter === 'Part-Time' ? 'Part time' : filter === 'Full-Time' ? 'Full time' : filter}
          </button>
        ))}
      </div>

      {/* Job cards */}
      {filteredJobs.length === 0 ? (
        <div className="text-center py-12 text-gray-400 text-sm">No jobs found for this filter.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {filteredJobs.map((job) => (
            <div
              key={job._id}
              className="bg-gray-50 border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow flex flex-col overflow-hidden"
            >
              <div className="p-5 flex-1 flex flex-col">
                {/* Title + work type */}
                <div className="flex items-start justify-between gap-3 mb-2">
                  <h3 className="text-base font-semibold text-gray-900 leading-snug line-clamp-2">
                    {job.jobTitle}
                  </h3>
                  <span className="shrink-0 text-xs font-medium text-orange-600 bg-orange-50 px-2.5 py-1 rounded-full whitespace-nowrap">
                    {job.workType}
                  </span>
                </div>

                {/* Details */}
                <div className="text-sm text-gray-600 space-y-1 mb-2">
                  <p className="flex items-center gap-1">
                    <span className="text-orange-500">★</span>
                    {job.localGovernment}, {job.state}
                  </p>
                  <p>Experience: {job.experienceLength}</p>
                  <p className="text-gray-500 text-xs">{getTimeAgo(job.createdAt)}</p>
                </div>

                <p className="font-semibold text-gray-800 text-sm mb-4">
                  Salary: {job.salary} {job.currency}
                </p>

                {/* Engagement stats — equal-width grid so nothing overlaps at any card width */}
                <div className="grid grid-cols-3 divide-x divide-gray-200 border-t border-gray-200 pt-3 mt-auto">
                  <StatItem
                    icon="❤️"
                    value={job.likes?.length || 0}
                    label="Likes"
                    iconBg="bg-rose-50"
                    textColor="text-rose-500"
                  />
                  <StatItem
                    icon="👁️"
                    value={job.uniqueViewers?.length || job.views || 0}
                    label="Views"
                    iconBg="bg-emerald-50"
                    textColor="text-emerald-600"
                  />
                  <StatItem
                    icon="🔗"
                    value={job.followers?.length || job.shares || 0}
                    label="Shares"
                    iconBg="bg-blue-50"
                    textColor="text-blue-600"
                  />
                </div>
              </div>

              {/* Apply button — full width footer, always its own row */}
              <Link
                to={`/job/${job._id}`}
                className="block text-center px-6 py-3 bg-orange-500 text-white font-medium hover:bg-orange-600 transition-colors"
              >
                Apply Now
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

function StatItem({ icon, value, label, iconBg, textColor }) {
  return (
    <div className={`flex flex-col items-center gap-1 px-1 cursor-pointer group ${textColor}`}>
      <div className={`${iconBg} w-8 h-8 rounded-lg flex items-center justify-center text-sm group-hover:scale-105 transition-transform`}>
        {icon}
      </div>
      <span className="font-semibold text-sm leading-none">{value}</span>
      <p className="text-[10px] text-gray-500 leading-none">{label}</p>
    </div>
  );
}

export default JobGrid;